import { render, staticRenderFns } from "./RoomSticker.vue?vue&type=template&id=6d83020b&scoped=true"
import script from "./RoomSticker.vue?vue&type=script&lang=js"
export * from "./RoomSticker.vue?vue&type=script&lang=js"
import style0 from "./RoomSticker.vue?vue&type=style&index=0&id=6d83020b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d83020b",
  null
  
)

export default component.exports